import React from 'react';
import { Input, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import styles from './styles';
import { connect } from 'react-redux';
import * as actions from '../../../actions/adjuntarArchivo';
import * as actionsVentanaDialogo from '../../../actions/ventanaDialogo';

import uploadIcono from '../../../assets/iconos/upload-icon.png';

const BtnAdjuntarArchivos = (props) => {
    const filtrarArchivosPorExtension = (archivos) => {
        const archivosFiltrados = archivos.filter((archivo) => {
            const extensiones = props.extensionesAceptadas.split(',');
            let arcValido = false;

            for (let i = 0; i < extensiones.length; i++) {
                const extension = extensiones[i];

                if (
                    archivo.name.toLowerCase().endsWith(extension) &&
                    !props.archivosSubidos.some(
                        (arch) =>
                            arch.nombreArchivo === archivo.name &&
                            !arch.bajaLogica
                    )
                ) {
                    arcValido = true;
                    break;
                }
            }

            return arcValido;
        });

        return archivosFiltrados;
    };

    const selectFile = async (event) => {
        const fullPath = 'presentaciones/file/' + props.seccion;
        const archivos = [...event.target.files];

        const archivosFiltrados = filtrarArchivosPorExtension(archivos);

        if (archivosFiltrados.length > 0) {
            props.archivosSeleccionados(
                archivosFiltrados,
                fullPath,
                props.archivosHandler,
                props.archivosSubidos,
                props.path
            );
        } else {
            const mensaje =
                'No se procesó ninguno de los archivos seleccionados, ya que no cumplen con las extensiones soportadas [*.jpg,*.jpeg,*.png,*.pdf] o se encuentran repetidos';

            const ventanaConfig = {
                estaVisible: true,
                titulo: 'Error al procesar archivos',
                mensaje: mensaje,
                esAlerta: true,
                clickAceptar: () =>
                    props.actualizarAtriutoVentanaDialogo({
                        estaVisible: false,
                    }),
            };

            props.actualizarAtriutoVentanaDialogo(ventanaConfig);
        }

        document.getElementById(props.seccion + 'InputFile').value = null;
    };

    if (props.deshabilitado) {
        return null;
    }

    return (
        <Button component='label' className={props.classes.btnAdjuntar}>
            <Input
                id={props.seccion + 'InputFile'}
                type='file'
                onChange={selectFile}
                inputProps={{
                    accept: props.extensionesAceptadas,
                    multiple: props.multiplesArchivos,
                    hidden: true,
                }}
            />
            <img
                src={uploadIcono}
                alt='Subir archivo'
                className={props.classes.iconoUpload}
            />
            Elegí un archivo
        </Button>
    );
};

const mapStateToProps = (state) => ({
    soloVista: state.nuevaPresentacionReducer.soloVista,
});

const actionCreators = {
    archivosSeleccionados: actions.archivosSeleccionados,
    actualizarAtriutoVentanaDialogo:
        actionsVentanaDialogo.actualizarAtriutoVentanaDialogo,
};

export default connect(
    mapStateToProps,
    actionCreators
)(withStyles(styles)(BtnAdjuntarArchivos));
